var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card-code', {
    attrs: {
      "title": "With Icon"
    },
    scopedSlots: _vm._u([{
      key: "code",
      fn: function fn() {
        return [_vm._v(" " + _vm._s(_vm.codeWithIcon) + " ")];
      },
      proxy: true
    }])
  }, [_c('app-timeline', [_c('app-timeline-item', {
    attrs: {
      "title": "Goal Achieved",
      "subtitle": "All milestones are completed",
      "icon": "AwardIcon",
      "time": "few minutes ago",
      "variant": "success"
    }
  }), _c('app-timeline-item', {
    attrs: {
      "title": "Last milestone remain",
      "subtitle": "You are just one step away from your goal",
      "icon": "InfoIcon",
      "time": "3 minutes ago",
      "variant": "info"
    }
  }), _c('app-timeline-item', {
    attrs: {
      "title": "Your are running low on time",
      "subtitle": "Only 30 minutes left to finish milestone",
      "icon": "ClockIcon",
      "time": "21 minutes ago",
      "variant": "warning"
    }
  }), _c('app-timeline-item', {
    attrs: {
      "title": "Client Meeting",
      "subtitle": "New event has been added to your schedule",
      "icon": "UserIcon",
      "time": "36 minutes ago"
    }
  }), _c('app-timeline-item', {
    attrs: {
      "title": "Product Design",
      "subtitle": "Product design added in workflow",
      "icon": "GridIcon",
      "time": "1 hour ago",
      "variant": "success"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }